"use client"

import {
  Eye,
  Globe,
  Lock,
  Radar,
  Shield,
  Zap,
  type LucideIcon,
} from "lucide-react"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { detectionCapabilities } from "@/lib/live-data"
import { useTranslations } from "@/lib/i18n/client"

const iconMap: Record<string, LucideIcon> = {
  shield: Shield,
  radar: Radar,
  lock: Lock,
  eye: Eye,
  zap: Zap,
  globe: Globe,
}

export function DetectionGridSection() {
  const t = useTranslations("detection")

  return (
    <SectionContainer id="detection" className="py-12 md:py-20">
      <div className="mb-8 space-y-2 text-center md:mb-12">
        <h2 className="text-2xl font-bold tracking-tight md:text-3xl">{t("title")}</h2>
        <p className="mx-auto max-w-2xl text-muted-foreground">{t("subtitle")}</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {detectionCapabilities.map((cap) => {
          const Icon = iconMap[cap.icon] ?? Shield
          return (
            <GlassCard
              key={cap.id}
              className="cyber-border group transition-colors hover:border-amber-500/30 hover:bg-white/[0.07]"
            >
              <div className="mb-4 flex size-10 items-center justify-center rounded-xl bg-amber-500/10 ring-1 ring-amber-500/20 transition-colors group-hover:bg-amber-500/20">
                <Icon className="size-5 text-amber-400" />
              </div>
              <h3 className="font-semibold">{t(cap.titleKey)}</h3>
              <p className="mt-2 text-sm text-muted-foreground">
                {t(cap.descriptionKey)}
              </p>
            </GlassCard>
          )
        })}
      </div>
    </SectionContainer>
  )
}
